import { Injectable } from '@angular/core';
import { PershingDecimalFormatPipe } from '@pershing/pershing-core';
import { BalancesConstants } from './balances-constants';

@Injectable()
export class BalancesCommonUtils {

    constructor(private decimalFormatting: PershingDecimalFormatPipe) {
    }

    replaceNullToZero = (num: number): number => {
        return num != null ? num : 0;
    }

    checkNullDisplay(value: any): any {
        if (value == null || value === '') {
            return BalancesConstants.HYPHEN;
        } else {
            return value;
        }
    }

    formatNumber(value: any, decimal: any): number | string {
        let response: any = value;
        if (typeof value === 'number') {
            response = this.decimalFormatting.transform(value, decimal);
        }
        return response;
    }

    checkNullFormatNumber(value: any): number | string {
        let response: any = value;
        if (typeof value === 'number') {
            value = value != null ? value : 0;
            response = this.decimalFormatting.transform(value, this.decimalFormatting.twoDecimals);
        }
        return response;
    }
    numberPipeTransform(obj: Object) {
        var keys = Object.keys(obj)
        for (let rowKey of keys) {
            var keyval = Object.keys(obj[rowKey])
            for (let rowKeyVal of keyval) {
                if (typeof (obj[rowKey][rowKeyVal]) === 'number') {
                    obj[rowKey][rowKeyVal] = this.decimalFormatting.transform(obj[rowKey][rowKeyVal], this.decimalFormatting.twoDecimals);
                }
            }
        }
        return (obj)
    }
}
